import {Store} from '@ngxs/store';
import {forkJoin, Observable} from 'rxjs';

import {AppConfigActions} from '../store';

export function appInit(store: Store): () => Observable<unknown> | Promise<unknown> {
    return () => forkJoin([store.dispatch(new AppConfigActions.GetAppConfig())]);
}
